// extracted by mini-css-extract-plugin
module.exports = {"hasSpacingBottom":"Teams-m__hasSpacingBottom___1lCle"};